import styles from './StanCard.module.css';
import { HTMLAttributes, ReactNode, Ref } from 'react';
import { cn } from '@/lib/utils/cn';

export interface StanCardProps extends HTMLAttributes<HTMLDivElement> {
    showCard?: boolean;
    children?: ReactNode;
    className?: string;
    ref?: Ref<HTMLDivElement>;
}

export const StanCard = ({ className = '', children, showCard = true, ref, ...rest }: StanCardProps) => {
    return (
        <div ref={ref} className={cn(showCard && styles.container, className)} {...rest}>
            {children}
        </div>
    );
};

StanCard.displayName = 'StanCard';
